export default __webpack_public_path__ + "static/media/recommendations-class-profile-preview.873ed682.png";